
export default function Hero() {
  const scrollToServices = () => {
    document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#0B1F3B] via-[#0d2847] to-[#0B1F3B]">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-64 h-64 bg-[#FF8A00] rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#FF8A00] rounded-full blur-3xl"></div>
      </div>

      {/* Tech Icons Background */}
      <div className="absolute inset-0 overflow-hidden opacity-5">
        <i className="ri-camera-line absolute top-20 left-20 text-9xl text-white"></i>
        <i className="ri-computer-line absolute top-40 right-32 text-8xl text-white"></i>
        <i className="ri-printer-line absolute bottom-40 left-40 text-7xl text-white"></i>
        <i className="ri-smartphone-line absolute bottom-32 right-20 text-9xl text-white"></i>
        <i className="ri-lightbulb-line absolute top-1/2 left-1/4 text-8xl text-white"></i>
      </div>

      <div className="container mx-auto px-4 py-20 relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          {/* Logo/Brand */}
          <div className="mb-8">
            <h1 className="text-5xl md:text-7xl font-bold text-white mb-2" style={{ fontFamily: '"Pacifico", serif' }}>
              Bastian Digital Service
            </h1>
            <div className="h-1 w-32 bg-[#FF8A00] mx-auto rounded-full"></div>
          </div>

          {/* Main Headline */}
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight">
            Semua Layanan Digital & Servis Ada di Sini
          </h2>

          {/* Subheadline */}
          <p className="text-lg md:text-xl text-gray-200 mb-8 max-w-3xl mx-auto leading-relaxed">
            Satu tempat untuk cetak foto, desain, percetakan, servis laptop & HP, CCTV, LED, undangan digital, PLTS, dan banyak lagi.
          </p>

          {/* WhatsApp Number Display */}
          <div className="mb-8 inline-flex items-center gap-3 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full border border-white/20">
            <i className="ri-whatsapp-fill text-2xl text-[#25D366]"></i>
            <span className="text-xl font-semibold text-white">0858-6836-0910</span>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href="https://wa.me/6285868360910"
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-[#25D366] hover:bg-[#20bd5a] text-white px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 flex items-center gap-3 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-fill text-2xl"></i>
              Chat WhatsApp
              <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
            </a>
            <button
              onClick={scrollToServices}
              className="group bg-[#FF8A00] hover:bg-[#e67d00] text-white px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 flex items-center gap-3 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Lihat Layanan
              <i className="ri-arrow-down-line text-xl group-hover:translate-y-1 transition-transform"></i>
            </button>
          </div>

          {/* Service Icons Preview */}
          <div className="mt-16 flex flex-wrap justify-center gap-8 opacity-80">
            {[
              { icon: 'ri-camera-line', label: 'Foto' },
              { icon: 'ri-palette-line', label: 'Desain' },
              { icon: 'ri-computer-line', label: 'Servis' },
              { icon: 'ri-webcam-line', label: 'CCTV' },
              { icon: 'ri-lightbulb-flash-line', label: 'LED' },
              { icon: 'ri-sun-line', label: 'PLTS' }
            ].map((item, index) => (
              <div key={index} className="flex flex-col items-center gap-2">
                <div className="w-16 h-16 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-2xl border border-white/20 hover:bg-white/20 transition-all duration-300">
                  <i className={`${item.icon} text-3xl text-[#FF8A00]`}></i>
                </div>
                <span className="text-sm text-gray-300">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-double-line text-3xl text-white/50"></i>
      </div>
    </section>
  );
}
